import { useMutation } from "react-query";
import UploadSKU from "@funded-here-interface/investor-onboarding/src/services/Uploadsku";
function useUploadSku() {
  return useMutation(["UploadSKU"], UploadSKU);
}

export default useUploadSku;
